import React from 'react';

const UserTwoFaCredentialFormModal = React.lazy(() => import('../components/FormModal'));
const userTwoFaCredentialModalRegistry = {
    core_userTwoFaCredentialId: UserTwoFaCredentialFormModal
};
export default userTwoFaCredentialModalRegistry;
